<p-table #dt
         [value]="rows()"
         [responsiveLayout]="'scroll'"
         [scrollable]="true"
         scrollHeight="calc(100vh - 300px)"
         scrollDirection="horizontal"
         class="inputs-table unified-table"
         [paginator]="false"
         >


  <ng-template pTemplate="header">
    <tr>
      <th class="frozen-column">
        <div class="column-header-container">
          <div class="header-title">Inputs</div>
        </div>
      </th>
      <ng-container *ngFor="let col of columns(); let i = index">
        <ng-container *ngIf="i !== 0">
          <th class="custom-column">
            <div class="column-header-container" [ngClass]="{'chevron-header': canEditChevronCase && col.caseId === 2}">
              <div class="header-title">{{ col.header }}</div>
        <div class="header-actions" *ngIf="canEditChevronCase && col.caseId === 2">
                <button 
                  class="chevron-save-btn"
          [disabled]="(savingChevron || preparingChevronConfirm || resetting) || !chevronDirty"
                  (click)="onSaveChevronClicked()"
          pTooltip="{{ (savingChevron || preparingChevronConfirm || resetting) ? (savingChevron ? 'Saving...' : (preparingChevronConfirm ? 'Preparing...' : 'Resetting...')) : (chevronDirty ? 'Save Chevron Case changes' : 'No changes to save') }}" tooltipPosition="bottom">
          <fa-icon [icon]="['fas', (savingChevron || preparingChevronConfirm || resetting) ? 'spinner' : 'save']" [ngClass]="{'fa-spin': (savingChevron || preparingChevronConfirm || resetting), 'dirty': chevronDirty, 'clean': !chevronDirty}"></fa-icon>
                </button>
              </div>
              <button *ngIf="col.deletable && canEditChevronCase"
                      class="delete-column-btn formated-button"
                      (click)="removeColumn(col.field)"
                      pTooltip="Remove column" tooltipPosition="bottom">
                <fa-icon [icon]="faXmark"></fa-icon>
              </button>
            </div>
          </th>
        </ng-container>
      </ng-container>
    </tr>
  </ng-template>
  

  <ng-template pTemplate="body" let-row>
    <tr [ngClass]="getRowClass(row)">
      <td class="frozen-column"  pTooltip="{{ getTooltipText(row, columns()[0], 0) }}">
        <span class="bullet"><fa-icon [icon]="['fas', 'circle']"></fa-icon></span>
        {{ row.name }}
      </td>
      <ng-container *ngFor="let col of columns(); let i = index">
        <ng-container *ngIf="i !== 0">
          <td [pEditableColumn]="(col.editable && (canEditChevronCase || col.deletable)) ? row[col.field] : null"
              pTooltip="{{ getTooltipText(row, col, i) }}">
      <ng-container *ngIf="col.editable && (canEditChevronCase || col.deletable); else readOnlyCell">
              <p-cellEditor>
                <ng-template pTemplate="input">
      <input pInputText [(ngModel)]="row[col.field]" type="text"
        (keypress)="validateNumberInput($event)"
        (paste)="validatePaste($event)" (ngModelChange)="onModelChange(row, col.field)" class="full-width-input" />
                </ng-template>
                <ng-template pTemplate="output">
          {{ row[col.field + '_display'] ?? row[col.field] }}
                </ng-template>
              </p-cellEditor>
            </ng-container>
            <ng-template #readOnlyCell>
        {{ row[col.field + '_display'] ?? row[col.field] }}
            </ng-template>
          </td>
        </ng-container>
    </ng-container>
    </tr>
  </ng-template>
  

</p-table>
